import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HolidaySummary from "app/pages/Booking/HolidaySummary/HolidaySummary/HolidaySummary";
import {
	getMaxLuggageCount,
	getFlightOptionsOfSelectedFlight,
	getAccommodations,
} from "app/pages/Booking/bookingSelectors";
import { matchPath } from "react-router-dom";
import withRouter from "app/utils/hocs/withRouter";
import get from "lodash/get";
import { OFFER_TYPES, RESOLUTION } from "app/constants";
import isEmpty from "lodash/isEmpty";
import { getSelectedActivitiesForPriceDetails } from "app/pages/Booking/Quotation/Activity/QuotationActivitySelectors";
import { getNegotiatedOfSelectedOffer } from "app/pages/PrePackage/searchEngineSelectors";
import { isFlashsaleProduct } from "app/utils/utils";
import { getStressMarketingLabel } from "app/pages/StressMarketing/stressMarketingSelector";
import { getQuotationPriceChangeData } from "app/pages/Booking/Quotation/quotationSelectors";
import { shouldShowTimer } from "app/pages/Listing/productsSelector";

const mapStateToProps = (state, props) => {
	const currentPathname = props.location.pathname;
	const isMobile = [RESOLUTION.SMALL, RESOLUTION.MEDIUM].includes(state.resolution);

	const isQuotePage = matchPath({ path: "/booking/quote" }, currentPathname);
	const isPaymentPage = matchPath({ path: "/booking/payment" }, currentPathname);
	const isConfirmationPage = matchPath({ path: "/booking/confirmation" }, currentPathname);
	const isRestoreSessionPage = matchPath({ path: "/booking/restoreSession" }, currentPathname);

	const isSDPQuotePage = matchPath({ path: "/sdp/booking/quote" }, currentPathname);
	const isSDPPaymentPage = matchPath({ path: "/sdp/booking/payment" }, currentPathname);
	const isSDPConfirmationPage = matchPath({ path: "/sdp/booking/confirmation" }, currentPathname);

	const isStopover = currentPathname.includes("stopover");
	const isSDP = currentPathname.includes("sdp");
	const isHotelOnly = currentPathname.includes("hotelonly");

	const ficheProduit = state.ficheProduit;
	const booking = state.booking || {};

	const stressMarketingMsg = getStressMarketingLabel(booking?.departureDate)(state);
	const accommodations = getAccommodations(state, isHotelOnly);

	return {
		isSDP,
		isHotelOnly,
		ficheProduit: ficheProduit,
		booking: booking,
		showTimer: shouldShowTimer(state) && isFlashsaleProduct(ficheProduit),
		negotiatedOfSelectedOffer: getNegotiatedOfSelectedOffer(state),
		showFlightDetails:
			(isQuotePage ||
				isSDPQuotePage ||
				isRestoreSessionPage ||
				isPaymentPage ||
				isSDPPaymentPage ||
				isConfirmationPage ||
				isSDPConfirmationPage) &&
			get(booking, "offer.type") === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION &&
			!isEmpty(booking.flight),
		luggageMaxCount: getMaxLuggageCount(state),
		quotationStatus: state.quotation?.status,
		activities: getSelectedActivitiesForPriceDetails(state),
		stressMarketingMsg: stressMarketingMsg,
		priceChangeData: getQuotationPriceChangeData(state),
		quotationCode: state.quotation?.code,
		flightOptions: getFlightOptionsOfSelectedFlight(state),
		flightOptionsFlightCode: state.quotation?.flightOptionsFlightCode,
		isStopover,
		accommodations,
		expandFlightDetails: (isSDPPaymentPage || isPaymentPage) && !isMobile,
	};
};

const mapDispatchToProps = dispatch => {
	return bindActionCreators({}, dispatch);
};

export default withRouter(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(HolidaySummary)
);
